/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change @his template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('SaleServiceView',["$sce","SaleServiceData","SaleService","$filter","CurrencyManager","NumberSeparatorType",
        function ($sce,SaleServiceData,SaleService,$filter,CurrencyManager,NumberSeparatorType)
        {

        var SaleServiceView = function (saleService,ssIndex,billPosition,saleView,parentSaleServiceView)
        {
            this.ssIndex = ssIndex; //model index
            this.posView = (saleView ? saleView.posView : null);
            this.saleView = saleView;
            this.serviceView = null;
            this.label = "";
            this.price = 0;
            this.priceInput = "";
            this.vat = null;
            this.vatCode = null;
            this.priceHT=0;
            this.originalPrice = 0;
            this.originalPriceInput = "";
            this.discountPercent = 0;
            this.hrView;
            this.subSaleServicesView = [];
            this.billPosition = billPosition;//position inside sale ->
            this.isSubSaleServicesViewHidden = true;
            this.uniqueSubSaleServiceHr = null;
            this.initialProportion = 0;

            if(parentSaleServiceView!==undefined && parentSaleServiceView!=null)
                this.parentSaleServiceView = parentSaleServiceView;
            else
                this.parentSaleServiceView = null;

            if (saleService)
                this.loadDataFrom(saleService);
            else
                this.initVat();
        }
        SaleServiceView.prototype.getModel = function()
        {
            if (this.ssIndex!=-1)
            {
                return SaleServiceData.getByIndex(this.ssIndex);
            }
            return null;

        }
        SaleServiceView.prototype.loadDataFrom = function(saleService)
        {
            //Assume here than the object in parameter contains only id (must load them)
            if (saleService)
            {
                if (saleService.service && this.getSaleView() && this.getPosView() && this.getPosView().domainView)
                    this.serviceView =  this.getPosView().domainView.getServiceView(saleService.service);
                this.label = saleService.label;
                this.price= saleService.price;
                if (saleService.vatCode)
                {
                    this.vat= saleService.vat;
                    this.vatCode= saleService.vatCode;
                }
                else
                {
                    if (this.getSaleView())
                    {
                        this.vat = this.getSaleView().vat;
                        this.vatCode = this.getSaleView().vatCode;
                    }
                }
                this.updatePriceHT();
                if (saleService.originalPrice!=null) {
                    this.originalPrice = saleService.originalPrice;
                } else {
                    this.originalPrice = this.price;
                }
                this.calculateSubSaleInitialProportion(this);

                this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
                this.priceInput = $filter('currencyFormatFilter')(this.price);
                this.discountPercent = saleService.discountPercent;
                if (saleService.humanResource && this.getSaleView() && this.getSaleView().posView)
                    this.hrView = this.getSaleView().posView.domainView.getHrView(saleService.humanResource);

                this.loadSubSaleServiceView(saleService);
            }
        }

        SaleServiceView.prototype.loadSubSaleServiceView = function(saleService){
            if (saleService && saleService.service)
            {
                this.subSaleServicesView = [];
                var sumSubServicesPrice = 0;
                for (var j = 0;j< saleService.subSaleServices.length;j++)
                {
                    var sssView = new SaleServiceView(saleService.subSaleServices[j], SaleServiceData.getIndexOf(saleService.subSaleServices[j]), String.fromCharCode(97 + j), null, this);
                    this.addSubSaleServiceView(sssView);
                    sumSubServicesPrice += sssView.price;

                }

                this.updateUniqueSubServiceHr();
            }
        }

        SaleServiceView.prototype.copyDataTo = function(saleService, parentSaleService)
        {
            if (saleService)
            {
                saleService.label = this.label;
                if (this.serviceView)
                    saleService.service = this.serviceView.getModel();
                saleService.price= this.price;
                saleService.vat = this.vat;
                saleService.vatCode= this.vatCode;
                saleService.parentSaleService = parentSaleService;

                saleService.originalPrice= this.originalPrice;
                if (this.discountPercent && typeof this.discountPercent ==='string')
                {
                    saleService.discountPercent = this.discountPercent.replace(",",".").replace(" ","");
                    saleService.discountPercent = parseFloat(saleService.discountPercent);
                }
                else
                    saleService.discountPercent= this.discountPercent;

                var newSale = this.saleView?this.saleView.getModel():null;
                if (saleService.sale && newSale!==saleService.sale)//remove
                    saleService.sale.removeSaleService(saleService);
                if (newSale)//Force add because removed by sale.updateModel
                    newSale.addSaleService(saleService);

                if (this.hrView)
                    saleService.humanResource = this.hrView.getModel();

                saleService.subSaleServices = [];
                var subSaleService = null;

                for (var i = 0;i < this.subSaleServicesView.length;i++)
                {
                    subSaleService = this.subSaleServicesView[i].getModel();

                    if (subSaleService == null)
                    {
                        subSaleService = new SaleService();
                        this.subSaleServicesView[i].servIndex = SaleServiceData.getIndexOf(subSaleService);
                    }
                    this.subSaleServicesView[i].copyDataTo(subSaleService, saleService);
                    saleService.subSaleServices.push(subSaleService);
                }
            }
        }

        SaleServiceView.prototype.getClone = function(saleView, parentClone)
        {
            var ssView = new SaleServiceView(null, -1, this.billPosition, saleView, parentClone);
            ssView.label = this.label;
            ssView.vatCode = this.vatCode;
            ssView.vat = this.vat;
            ssView.serviceView = this.serviceView;
            ssView.price = this.price;
            ssView.priceInput = this.priceInput;
            ssView.originalPrice = this.originalPrice;
            ssView.originalPriceInput = this.originalPriceInput;
            ssView.discountPercent = this.discountPercent;
            ssView.hrView = this.hrView;

            for (var i = 0;i<this.subSaleServicesView.length;i++)
                ssView.subSaleServicesView.push(this.subSaleServicesView[i].getClone(null, this));

            return ssView;
        };

        SaleServiceView.prototype.calculateSubSaleInitialProportion = function(subSaleServiceView) {
            if(subSaleServiceView.parentSaleServiceView) {
                let originalPrice = subSaleServiceView.parentSaleServiceView.originalPrice;
                if(originalPrice === 0 || isNaN(originalPrice)) {
                    let subServiceView = subSaleServiceView.serviceView;
                    if(subServiceView && subServiceView.parentServiceView && subServiceView.parentServiceView.price !== 0){
                        subSaleServiceView.initialProportion = subServiceView.price / subServiceView.parentServiceView.price;
                    }
                } else {
                    subSaleServiceView.initialProportion = subSaleServiceView.originalPrice / originalPrice;
                }
            }
        };

        SaleServiceView.prototype.setPriceAsCredit = function()
        {
            this.price = -this.price;
            for (let i = 0;i<this.subSaleServicesView.length;i++) {
                this.subSaleServicesView[i].price = -this.subSaleServicesView[i].price;
            }
        };
        SaleServiceView.prototype.loadBookingServiceView = function(bsView)
        {
            this.label = bsView.label;
            this.serviceView = bsView.serviceView;
            this.price= bsView.price;
            this.priceInput= bsView.priceInput;
            this.originalPrice= bsView.originalPrice;
            this.originalPriceInput= bsView.originalPriceInput;
            this.discountPercent= bsView.discountPercent;
            if (bsView.plgDayHrView)
                this.hrView = bsView.plgDayHrView.hrView;
        }

        SaleServiceView.prototype.updateOriginalPriceInputArrow = function(number) {
            if (this.getSaleView() && !this.getSaleView().isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput ==='string') {
                let originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                let originalPrice = parseFloat(originalPriceStr);
                if(originalPrice !== "NaN") {
                    originalPrice += number;
                }
                this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
                this.updateOriginalPrice(originalPrice);
                this.updatePrice();
            }
        }

        SaleServiceView.prototype.onOriginalPriceInputChange = function() {
            if (this.getSaleView() && !this.getSaleView().isReadOnly && this.originalPriceInput!=null && typeof this.originalPriceInput ==='string') {
                let originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                let originalPrice = parseFloat(originalPriceStr);

                this.updateOriginalPrice(originalPrice);
                this.updatePrice();
            }
        }

        SaleServiceView.prototype.updateOriginalPrice = function(newOriginalPrice) {
            if(newOriginalPrice && newOriginalPrice !== "NaN") {
                this.originalPrice = newOriginalPrice;
            } else {
                this.originalPrice =  null;
            }

            for (let subSaleServiceView of this.subSaleServicesView) {
                let subServiceNewOriginalPrice = subSaleServiceView.initialProportion * newOriginalPrice;
                if (subServiceNewOriginalPrice !== "NaN" && !isNaN(subServiceNewOriginalPrice)) {
                    subSaleServiceView.originalPrice = subServiceNewOriginalPrice;
                } else {
                    subSaleServiceView.originalPrice = null;
                }
            }
        }

        SaleServiceView.prototype.updatePriceInputArrow = function(number)
        {
            if (this.getSaleView() && !this.getSaleView().isReadOnly && this.priceInput!=null && typeof this.priceInput ==='string') {
                var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
                var price = parseFloat(priceStr);
                if(price !== "NaN")
                    price+= number;

                this.price = price;
                this.priceInput = $filter('currencyFormatFilter')(price);
            }
        }

        SaleServiceView.prototype.updateDiscountPercentSubServices = function()
        {
            if(this.subSaleServicesView.length > 0)
            {
                for(var i = 0; i < this.subSaleServicesView.length; i++)
                {
                    this.subSaleServicesView[i].discountPercent = this.discountPercent;
                }
            }
        }

        SaleServiceView.prototype.onDiscountPercentInputChange = function()
        {
            this.getSaleView().checkForInvalidAmounts();
            this.updateDiscountPercentSubServices();
            this.updatePrice();
        }

        SaleServiceView.prototype.onPriceInputChange = function()
        {
            if (this.getSaleView() && !this.getSaleView().isReadOnly && this.priceInput!=null && typeof this.priceInput ==='string') {
                var priceStr = CurrencyManager.getPriceFromPriceInput(this.priceInput);
                var price = parseFloat(priceStr);
                if(price !== "NaN")
                {
                    this.price = price;
                    this.priceInput = $filter('currencyFormatFilter')(this.price);
                }
                else
                    this.price = null;
            }
        }

        SaleServiceView.prototype.hasSubSaleServiceView = function(saleServiceView)
        {
            return (this.subSaleServicesView.indexOf(saleServiceView)!=-1);
        }

        SaleServiceView.prototype.addSubSaleServiceView = function(saleServiceView)
        {
            if (saleServiceView &&! this.hasSubSaleServiceView(saleServiceView)) {
                this.subSaleServicesView.push(saleServiceView);
                this.updateUniqueSubServiceHr();
            }
        }

        SaleServiceView.prototype.setService = function(serviceView)
        {
            this.serviceView = serviceView;
            if (serviceView!=null)
            {
                this.label = serviceView.label;
                this.originalPrice = serviceView.price;
                this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);

                if(serviceView.isPackage && serviceView.subServicesView && serviceView.subServicesView.length !=0)
                {
                    var sumSubServicesPrice = 0;

                    for (var j = 0; j < serviceView.subServicesView.length; j++)
                    {
                        var sssView = new SaleServiceView(null, -1, String.fromCharCode(97 + j), null, this);
                        sssView.setService(serviceView.subServicesView[j]);//set activity end using service duration
                        this.addSubSaleServiceView(sssView);

                        if(this.originalPrice !== 0) {
                            sssView.initialProportion = sssView.originalPrice / this.originalPrice;
                        }
                        else if(serviceView.getDurationWithHR() !== 0){
                            sssView.initialProportion = serviceView.subServicesView[j].getDurationWithHR() / serviceView.getDurationWithHR();
                        }
                        sumSubServicesPrice += sssView.price;
                    }
                }
                this.updatePrice();
            }
        }

        SaleServiceView.prototype.initVat = function()
        {
            if(this.getPosView() && this.getPosView().domainView)
            {
                var vatView = this.getPosView().domainView.getDefaultVatView();
                if (vatView) {
                    this.vat = vatView.tax;
                    this.vatCode = vatView.code;
                }
            }
        }

        SaleServiceView.prototype.onHrViewInputChange = function(hrView)
        {
            this.setHrView(hrView);
            if(this.parentSaleServiceView)
                this.parentSaleServiceView.updateUniqueSubServiceHr();
        }

        SaleServiceView.prototype.setHrView = function(hrView)
        {
           this.hrView = hrView;
        }

        SaleServiceView.prototype.updateUniqueSubServiceHr = function() {
            var uniqueSubServiceHR = null;
            var isHidden = true;
            if(this.subSaleServicesView.length != 0){
                uniqueSubServiceHR = this.subSaleServicesView[0].hrView;

                for(var i = 1; i < this.subSaleServicesView.length; i ++){
                    if(this.subSaleServicesView[i].serviceView && this.subSaleServicesView[i].serviceView.nbHrsNeeded && this.subSaleServicesView[i].hrView !== uniqueSubServiceHR){
                        uniqueSubServiceHR = null;
                        isHidden = false;
                        break;
                    }
                }
            }
            this.uniqueSubSaleServiceHr = uniqueSubServiceHR;
            if(uniqueSubServiceHR)
                this.isSubSaleServicesViewHidden = isHidden;
            else
                this.isSubSaleServicesViewHidden = false;
        }

        SaleServiceView.prototype.hasUniqueSubSaleServiceHR = function()
        {
            var isUniqueHR = true;

            for(var i = 0; i < this.subSaleServicesView.length; i ++){
                if(this.subSaleServicesView[i].hrView !== hrView){
                    isUniqueHR = false;
                    break;
                }
            }
            return isUniqueHR;
        }

        SaleServiceView.prototype.getSaleView = function()
        {
            if(this.parentSaleServiceView)
                return this.parentSaleServiceView.getSaleView();
            else
                return this.saleView;
        }

        SaleServiceView.prototype.getPosView = function()
        {
            if(this.parentSaleServiceView)
                return this.parentSaleServiceView.getPosView();
            else
                return this.posView;
        }

        SaleServiceView.prototype.updatePriceHT = function()
        {
            this.priceHT = Math.round((100 / (100 + this.vat) * this.price) * 100) / 100;
        }

        SaleServiceView.prototype.updateDiscountPercent = function(step)
        {
            if (this.getSaleView() && !this.getSaleView().isReadOnly) {
                var newDiscountPercent = (this.discountPercent * 1) + step;//multiplication by 1 in order to use javascript auto-conversion in number
                if (newDiscountPercent > 100)
                    this.discountPercent = 100;
                else if (newDiscountPercent < 0)
                    this.discountPercent = 0;
                else
                    this.discountPercent = newDiscountPercent;
            }
        }

        SaleServiceView.prototype.onDiscountPercentInputArrowClick = function(step)
        {
            this.updateDiscountPercent(step);
            this.updateDiscountPercentSubServices();
            this.updatePrice();
        }

        SaleServiceView.prototype.updatePercentOnPriceChange = function()
        {
            this.discountPercent =  Math.round(100*(100- 100* this.price/this.originalPrice))/100;
            this.updatePriceHT();
            this.getSaleView().resetPayments();
            this.getSaleView().calculateSaleFields();
        }

        SaleServiceView.prototype.updatePrice = function() {
            var oriPrice = this.originalPrice;
            var discount = 0;
            var discountPercent = this.discountPercent;
            if (discountPercent && typeof discountPercent === 'string') {
                discountPercent = discountPercent.replace(",", ".").replace(" ", "");
                discountPercent = parseFloat(discountPercent);
            }
            if (discountPercent != 0)
                discount = Math.round((discountPercent * oriPrice / 100) * 100) / 100;

            if ((oriPrice - discount) != this.price) {
                this.price = (oriPrice - discount);
                this.priceInput = $filter('currencyFormatFilter')(this.price);
                this.updatePriceHT();
                this.getSaleView().resetPayments();
                this.getSaleView().calculateSaleFields();
            }
            this.updateSubServicesPrice();
            this.getSaleView().checkForInvalidAmounts();
        }

        SaleServiceView.prototype.updateSubServicesPrice = function () {
            if (this.subSaleServicesView.length > 0)
            {
                for (var i = 0; i < this.subSaleServicesView.length; i++)
                {
                    this.subSaleServicesView[i].updatePrice();
                }
            }
        }

        SaleServiceView.prototype.selectService = function () {
            if (this.serviceView)
                this.serviceView.isSelected = true;
        }

        SaleServiceView.prototype.updateModel = function()
        {
            var saleService = this.getModel();
            if (saleService == null)
            {
                saleService = new SaleService();
                this.ssIndex = SaleServiceData.getIndexOf(saleService);
            }
            this.copyDataTo(saleService);
        }

        SaleServiceView.prototype.removeModel = function()
        {
            var saleService = this.getModel();
        }

        SaleServiceView.prototype.reloadModel = function()
        {
            var saleService = this.getModel();
            if (saleService==null)
            {
                //this.parentCategoryView.removeSaleServiceView(this);
            }
            else
            {
                this.loadDataFrom(saleService);
            }
        }

        SaleServiceView.prototype.canSave = function()
        {
            if (!this.serviceView)
                return false;

            if(this.originalPrice == "NaN" || this.originalPrice == "")
                this.originalPrice = null;

            return (this.label && this.label!="") //titre
                && (this.originalPrice && this.originalPrice>=0); //prix (décimal)
        }

        return SaleServiceView;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/views/SaleServiceView.js